import { useFormContext } from 'react-hook-form'
import { OfferSchemaValidationType } from '../../validations/offer-validation'

export const DesktopBanner: React.FC = () => {
  const { watch } = useFormContext<OfferSchemaValidationType>()
  const { bannerDesktopUrl, creatorLogoUrl } = watch('checkout')
  return (
    <div style={{ maxHeight: '120px', position: 'relative' }}>
      <img
        style={{ maxHeight: '120px', objectFit: 'cover' }}
        width="100%"
        height="auto"
        src={bannerDesktopUrl!}
        alt="banner desktop"
      />
      {creatorLogoUrl && (
        <img
          style={{
            maxHeight: '60px',
            maxWidth: '120px',
            objectFit: 'cover',
            position: 'absolute',
            bottom: '12px',
            left: '58px',
            zIndex: 1,
          }}
          width="100%"
          height="auto"
          src={creatorLogoUrl!}
          alt="logo do criador"
        />
      )}
    </div>
  )
}
